import { createTheme } from '@material-ui/core'
import shadows from './shadow'

const customMaterialTheme = (globalTheme) => {
  const shadowsFromTheme = shadows(globalTheme.colors?.shadow)

  return createTheme({
    palette: {
      primary: {
        main: globalTheme.colors.primaryButtonBackground,
        light: globalTheme.colors.primaryButtonText,
      },
      secondary: {
        main: globalTheme.colors.secondaryButtonBackground,
        light: globalTheme.colors.secondaryButtonText,
      },
      error: {
        main: globalTheme.colors.primaryButtonBackground,
        light: globalTheme.colors.primaryButtonText,
      },
    },
    shadows: shadowsFromTheme,
    typography: {
      fontFamily: ['Lato', 'Arial'].join(','),
    },
    background: {
      paper: globalTheme.colors.backgroundLight,
    },
    props: {
      MuiCard: {
        elevation: 0,
      },
      MuiButton: {
        disableElevation: true,
        variant: 'contained',
        color: 'primary',
      },
    },
    overrides: {
      MuiStepIcon: {
        root: {
          color: '#ffffff',
          border: `1px solid #d5dee6`,
          borderRadius: '50%',
        },
        active: {
          color: `${globalTheme.colors.secondaryButtonBackground} !important`,
          border: `1px solid #005bb5`,
        },
        text: {
          fill: '#ffffff !important',
          fontWeight: 600,
        },
        completed: {
          background: '#ffffff',
          borderRadius: '50%',
          color: '#43bc23 !important',
          border: `1px solid #2E7E19`,
        },
      },
      MuiStep: {
        horizontal: {
          '& .MuiStepIcon-root': {
            width: 37,
            height: 37,
            marginTop: -6,
          },
        },
      },
      MuiStepConnector: {
        completed: {
          '& span': {
            borderColor: '#43bc23 !important',
          },
        },
        vertical: {
          padding: 0,
          marginLeft: 12,
        },
        alternativeLabel: {
          left: 'calc(-50% + 20px)',
          right: 'calc(50% + 20px)',
        },
        line: {
          borderColor: '#d5dee6',
        },
        lineVertical: {
          height: '100%',
          borderLeftWidth: 3,
        },
        lineHorizontal: {
          height: '100%',
          borderTopWidth: 2,
        },
        active: {
          '& span': {
            borderColor: '#43bc23 !important',
          },
        },
      },
      MuiPaginationItem: {
        root: {
          backgroundColor: '#ffffff',
          border: `1px solid #D5DEE6`,
          fontWeight: 'bold',
        },
      },
      MuiCheckbox: {
        root: {
          paddingLeft: '0px',
          color: globalTheme.colors.greylight,
          fontSize: '2rem !important',
        },
        colorPrimary: {
          '&$checked': {
            color: globalTheme.colors.checkboxPrimary,
            borderColor: globalTheme.colors.checkboxBorderPrimary,
          },

          '&:hover': {
            backgroundColor: 'transparent !important',
          },
        },
      },
      MuiFormControl: {
        root: {
          minWidth: 210,
        },
      },
      MuiInputBase: {
        root: {
          borderRadius: 4,
          position: 'relative',
          border: `1px solid ${globalTheme.colors.greylight}`,
          fontSize: 16,
          //width: '100%',
          height: '2.8rem',
          padding: '1.5rem .75rem',
        },
        inputAdornedEnd: {
          width: '100%',
        },
        multiline: {
          minHeight: '18vh',
          width: '100vw',
          padding: '15% 2%',
        },
        inputMultiline: {
          height: '16vh !important',
        },
      },
      MuiAccordion: {
        root: {
          '&$expanded': {
            margin: 0,
            zIndex: 1,
            marginBottom: 2,
          },
          '&$expanded:before': {
            opacity: '1 !important',
          },
          '&:before': {
            display: 'block !important',
          },
        },
      },
      MuiChip: {
        root: {
          borderRadius: 4,
          color: '#222120',
          borderColor: '#D5DEE6',
          borderWidth: 1,
          borderStyle: 'solid',
          backgroundColor: '#F5F6FA',
        },
      },
      MuiAccordionSummary: {
        root: {
          display: 'flex',
          border: `1px solid ${globalTheme.colors.greylight}`,
          boxShadow: 'none',
          borderRadius: '5px',
          '&$expanded': {
            borderBottom: 0,
            borderRadius: '6px 6px 0 0',
            minHeight: '48px',
            margin: 0,
          },
        },
        content: {
          '&$expanded': {
            margin: '12px 0',
          },
        },
      },
      MuiAccordionDetails: {
        root: {
          border: `1px solid ${globalTheme.colors.greylight}`,
          borderTop: 0,
          flexDirection: 'column',
          zIndex: 1,
        },
      },
      MuiAutocomplete: {
        inputRoot: {
          padding: '0px !important',
        },
        listbox: {
          padding: 0,
        },
      },
      MuiInputLabel: {
        root: {
          fontSize: '9px',
          color: globalTheme.colors.primaryTextWeb,
          margin: '0 0 .6vh 0',
          display: 'flex',
          justifyContent: 'space-between',
        },
      },
      MuiInput: {
        underline: {
          '&:before': {
            color: 'transparent',
            borderBottom: '0px !important',
          },
        },
      },
      MuiButton: {
        root: {
          fontWeight: 'bold',
        },
        containedPrimary: {
          border: '1px',
          borderColor: '#C5243C',
          borderStyle: 'solid',

          '&$disabled': {
            border: '0px !important',
          },
        },
        containedSecondary: {
          border: '1px',
          borderColor: '#005bb5',
          borderStyle: 'solid',

          '&$disabled': {
            border: '0px !important',
          },
        },
        contained: {
          backgroundColor: '#ffffff',
        },
        outlined: {
          textTransform: 'none',
          borderRadius: 3,
          color: globalTheme.colors.primaryButtonText,
          backgroundColor: globalTheme.colors.primaryButtonBackground,
          padding: 0,
          minWidth: 188,
          lineHeight: 1,
          height: 33,
          textAlign: 'center',
          '&$disabled': {
            border: '0px !important',
            backgroundColor: `${globalTheme.colors.greylight} !important`,
            color: `${globalTheme.colors.primaryButtonText} !important`,
          },
        },
      },
      MuiFormControlLabel: {
        root: {
          width: '100%',
        },
        label: {
          width: '100%',
        },
      },
      MuiLink: {
        underlineHover: {
          textDecoration: 'underline',
        },
      },
      MuiCardContent: {
        root: {
          padding: 24,
        },
      },
      MuiCard: {
        root: {
          border: '1px solid #D5DEE6',
          borderRadius: '3px',
        },
      },
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
        root: {
          width: '100%',
          '& :focus': {
            backgroundColor: 'transparent',
            border: 0,
            color: 'green',
          },
        },
        icon: {
          paddingRight: '.5vw',
        },
      },
      MuiFab: {
        root: {
          boxShadow: 0,
        },
        primary: {
          backgroundColor: globalTheme.colors.buttonBackgroundAccept,
          border: `1px solid ${globalTheme.colors.fabPrimary}`,
          color: globalTheme.colors.fabPrimary,
          '&:hover': {
            backgroundColor: globalTheme.colors.buttonBackgroundDecline,
          },
        },
        secondary: {
          backgroundColor: globalTheme.colors.buttonHoverDecline,
          border: `1px solid ${globalTheme.colors.grey}`,
          '&:hover': {
            backgroundColor: globalTheme.colors.buttonBackgroundDecline,
          },
        },
      },
      MuiRadio: {
        colorSecondary: {
          '&$checked': {
            color: globalTheme.colors.fabPrimary,
          },
        },
      },
      MuiList: {
        padding: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
  })
}

export default customMaterialTheme
